import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type ChevronIconProps = {
  isOpen: boolean;
  className?: string;
};
const AnimatedChevronIcon = t0 => {
  const $ = _c(9);
  const {
    isOpen,
    className
  } = t0;
  const t1 = isOpen && "-rotate-180";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cx("flex items-center justify-center transition-transform duration-100 ease-in-out motion-reduce:transition-none", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M4.103 5.664a.657.657 0 0 0-.423.583c0 .244-.049.189 1.864 2.107.992.995 1.851 1.836 1.91 1.871.275.162.639.188.959.069.153-.058.24-.14 1.994-1.89 1.663-1.66 1.837-1.842 1.876-1.96.168-.506-.357-.981-.843-.762-.092.041-.509.442-1.78 1.712L8 9.053 6.34 7.394c-1.271-1.27-1.688-1.671-1.78-1.712a.638.638 0 0 0-.457-.018" fillRule="evenodd" fill="currentColor" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== className) {
    t4 = <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" className={className} role="img" data-colored={false}>{t3}</svg>;
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default AnimatedChevronIcon;